import { CONTACT } from "@/data/site";

export const waUrl = (message) =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(message)}`;

export const openWhatsApp = (message) => {
  window.open(waUrl(message), "_blank", "noopener,noreferrer");
};
